/* eslint-disable */
import requestRawBasic from '@/utils/requestRawBasic'
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function withdrawList(params) {
  return requestDev({
    url: APIReportPHP() + '/zeus/referral/withdraw-list',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function getBalance() {
  return requestRaw({
    url: APICore() + '/zeus/affiliate/balance',
    method: 'GET',
  })
}
export function images() {
  return requestRawBasic({
    url: APICore() + '/affiliate-pub/images',
    method: 'GET',
  })
}

export function detail(code) {
  return requestRawBasic({
    url: APICore() + '/affiliate-pub/info?ref=' + code,
    method: 'GET',
  })
}

export function statThisMonth() {
  return requestDev({
    url: APIReportPHP() + '/zeus/referral/stat-thismonth',
    method: 'GET',
  })
}

export function statLastMonth() {
  return requestDev({
    url: APIReportPHP() + '/zeus/referral/stat-lastmonth',
    method: 'GET',
  })
}

export function orderList(params) {
  return requestDev({
    url: APIReportPHP() + '/zeus/referral/order-list',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function memberList(params) {
  return requestDev({
    url: APIReportPHP() + '/zeus/referral/member-list',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function check() {
  return requestRaw({
    url: APICore() + '/affiliate/check',
    method: 'GET',
  })
}

export function shareLink() {
  return requestRaw({
    url: APICore() + '/affiliate/share-link',
    method: 'GET',
  })
}

export function info() {
  return requestRaw({
    url: APICore() + '/affiliate/info',
    method: 'GET',
  })
}

export function join() {
  return requestRaw({
    url: APICore() + '/affiliate/join',
    method: 'POST',
  })
}



// WEBPACK FOOTER //
// ./src/api/referral.js